module.exports = __webpack_public_path__ + "static/media/active-image-icon.eca4392a.svg";